import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgDoordash = function SvgDoordash(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M15.226 16.507H12.71a1.19 1.19 0 0 1-.45-.088 1.131 1.131 0 0 1-.382-.253L9.385 13.69a.38.38 0 0 1-.114-.313.383.383 0 0 1 .276-.333.362.362 0 0 1 .114-.017h5.562a1.035 1.035 0 0 0 1.03-1.038 1.032 1.032 0 0 0-1.05-1.016H7.135c-.313 0-.612-.123-.831-.341L3.81 8.156a.38.38 0 0 1-.106-.198.398.398 0 0 1-.007-.113.393.393 0 0 1 .39-.352H15.53a4.083 4.083 0 0 1 3.613 2.133c1.828 3.428-.647 6.881-3.918 6.881Z",
      stroke: "currentColor",
      strokeWidth: 1.3
    }))
  }));
};
export default SvgDoordash;